<div [ngClass]="['signout-overlay', visible ? 'show' : '']" >
    <div class="signout-container" #signOutContainer>
        <div class="title">
            <div data-cy="auto-logout-title" class="subtitle bold">
                {{ 'dlg.signin.auto-signout' | translate }}
            </div>
            <div data-cy="auto-logout-info-text" class="text light">
                {{ 'dlg.signin.auto-signout.description' | translate }}
            </div>
        </div>
        <div data-cy="auto-logout-login-button" class="signin-btn caption" (click)="onLogin()">Login</div>
        <div data-cy="auto-logout-close-button" class="close-btn caption" (click)="onClose()">Close</div>
    </div>
</div>
